import { StaffActivitiesByDescription, StaffActivityDetails } from "../../types";

const MN_STATE_PORTAL_BASE: StaffActivityDetails = {
  parameters: {
    linkUrls: ["https://minnesota.hazconnect.com/Account/Login.aspx"],
    staffInputs: {
      documentTypes: {
        report: true,
      },
    },
  },
  jurisdictionType: "State",
  activityType: "Portal",
  state: "MN",
};

export const staffActivities: StaffActivitiesByDescription = {
  "Minnesota State Portal": {
    ...MN_STATE_PORTAL_BASE,
    parameters: {
      ...MN_STATE_PORTAL_BASE.parameters,
      staffInputs: {
        ...MN_STATE_PORTAL_BASE.parameters.staffInputs,
        fees: true,
        documentTypes: {
          ...MN_STATE_PORTAL_BASE.parameters.staffInputs?.documentTypes,
          invoice: true,
        },
      },
    },
  },
  "Minnesota State Portal - Revision": {
    ...MN_STATE_PORTAL_BASE,
    parameters: {
      ...MN_STATE_PORTAL_BASE.parameters,
      staffInputs: {
        ...MN_STATE_PORTAL_BASE.parameters.staffInputs,
        fees: false,
      },
    },
  },
  "Minnesota Portal Newly Not Reporting": {
    parameters: {
      staffInputs: {
        documentTypes: {
          proof: true,
        },
      },
    },
    jurisdictionType: "State",
    activityType: "Portal",
    state: "MN",
  },
};
